




































import { User } from 'oidc-client';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { ReportsApi, ReportStorage } from 'performo-api';

import Modal from '@/components/util/Modal.vue';

@Component({
  components: {
    Modal
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    api: 'reportsApi'
  })
})
export default class ReportPreview extends Vue {
  @Prop({ required: true })
  private queueId!: number;

  private currentPropertyId!: string;
  private currentUser!: User;
  private api!: ReportsApi;

  private loading = false;
  private modalShow = false;
  private wasProblem = false;

  private report?: ReportStorage = undefined;

  data() {
    return {
      loading: false,
      wasProblem: false
    };
  }

  private get reportBlob() {
    if (this.report && this.report.reportData) {
      // https://stackoverflow.com/a/16245768/86860
      // convert our base64 pdf into a blob that can be pushed
      // into the object tag data attribute or used to download a file
      const byteCharacters = atob(this.report.reportData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      return blob;
    }
    return undefined;
  }

  private async downloadHandler() {
    if (this.report && this.reportBlob) {
      // something with the preview didn't work, so attempt to download the file.
      const fr = new FileReader();
      fr.onload = (evtLoaded: ProgressEvent<FileReader>) => {
        const a = document.createElement('a');
        a.style.display = 'none';
        if (evtLoaded.target && evtLoaded.target.result) {
          a.href = evtLoaded.target.result?.toString();
        }
        // the filename you want
        a.download = 'performo-report.pdf';
        document.body.appendChild(a);
        a.click();
      };
      fr.readAsDataURL(this.reportBlob);
    }
  }

  @Watch('modalShow')
  private async loadReportPreview(newModal: boolean) {
    if (this.queueId && newModal === true) {
      // reset loading true and problem false for re-try
      this.loading = true;
      this.wasProblem = false;

      // load the report
      await this.api
        .getReportByQueueId({ queueId: this.queueId })
        .then((rpt) => {
          this.report = rpt;
        })
        .catch(() => {
          this.wasProblem = true;
        })
        .finally(() => (this.loading = false));

      // if we have a report blob, attempt to push it into the object element.
      if (this.reportBlob) {
        const fr = new FileReader();
        fr.onload = (evtLoaded: ProgressEvent<FileReader>) => {
          const ob = this.$refs.rptPreview as HTMLObjectElement;
          if (evtLoaded.target && evtLoaded.target.result) {
            ob.data = evtLoaded.target.result.toString();
          }
        };
        fr.readAsDataURL(this.reportBlob);
      }
    }
  }
}
